module.exports = __webpack_public_path__ + "img/upgrade8.7f13312c.png";